<template>
  <div
    class="input-cell"
    ref="cell"
    contenteditable="true"
    @blur="onBlur"
    @focus="onFocus"
    @input="onInput"
  ></div>
</template>

<script>
import {
  getLastCellMatch,
  isSpecialCharAtEnd,
  setCursorAtLast,
} from '../../utils/helpers/SpreadSheetHelder';

export default {
  props: {
    rowIndex: Number,
    colIndex: Number,
    cellObject: Object,
    sheetData: Array,
  },
  data() {
    return {
      iShowFormula: false,
    };
  },
  methods: {
    setInitialValue() {
      try {
        this.$refs.cell.innerText = this.cellObject.formula
          ? this.cellObject.formula
          : this.cellObject.value;
      } catch (error) {
        console.log('error', error);
      }
    },
    onFocus(event) {
      this.$emit('onFocus', event);
    },
    onBlur(event) {
      try {
        if (!event.target) return;
        let innerText = event.target.innerText.trim();
        let value = innerText;
        let formula = '';

        if (innerText.startsWith('=')) {
          innerText = event.target.innerText.trim();
          formula = innerText;
          value = '';
          if (formula !== this.cellObject.formula) {
            value = '';
          } else {
            value = this.cellObject.value;
          }
        } else if (this.cellObject.value && value == this.cellObject.value) {
          formula = this.cellObject.formula;
        }

        this.$nextTick(() => {
          event.target.innerText = value ? value : formula?.toUpperCase() || '';
        });
        this.$emit('onBlur', {
          rowIndex: this.rowIndex,
          colIndex: this.colIndex,
          value,
          formula: formula?.toUpperCase() || null,
        });
      } catch (error) {
        console.log('error', error);
      }
    },
    onInput(event) {
      const innerText = event.target?.innerText?.trim() || '';
      this.$emit('onInput', innerText);
    },
    removeAllButLastOfLastItem(cellStr, splitSign = ';') {
      const cells = cellStr.split(splitSign);
      const last = cells[cells.length - 1];

      const isDuplicate = cells.slice(0, -1).includes(last);

      if (isDuplicate) {
        return cells.filter((cell) => cell !== last).join(splitSign);
      }

      return cellStr;
    },
    updateFormulaRef(formula, newRef) {
      if (typeof formula !== 'string' || typeof newRef !== 'string')
        return formula;

      const trimmed = formula.trim();

      if (!trimmed.startsWith('=')) return formula;

      // Case 1: If ends with one of the special characters, just append newRef
      if (isSpecialCharAtEnd(trimmed)) return trimmed + newRef;

      // Case 2: If ends with valid cell ref or range, replace it
      const match = getLastCellMatch(trimmed);

      if (match) {
        const matchedRef = match[1];
        const start = trimmed.lastIndexOf(matchedRef);
        const end = start + matchedRef.length;
        return trimmed.slice(0, start) + newRef + trimmed.slice(end);
      }

      return formula;
    },
    appendToFormula(newRef, isAppend = false, isReplace = false) {
      const cellDiv = this.$refs.cell;
      if (!cellDiv) return;

      try {
        let content = cellDiv.innerText.trim();

        if (isReplace) {
          cellDiv.innerText = newRef;
          setCursorAtLast(cellDiv);
          return;
        }

        const parts = newRef.split(':');
        if (parts[0] === parts[1]) newRef = parts[0];
        let updateContent = '';

        if (isAppend) {
          if (content === '=') {
            if (newRef === ')') return;
            updateContent = `${content}${newRef}`;
          } else {
            if (isSpecialCharAtEnd(content)) {
              if (newRef === ')') return;

              updateContent = `${content}${newRef}`;
            } else {
              const match = getLastCellMatch(content);
              if (!match) return;
              if (newRef === ')') {
                const startsWithFunction = /^=.+?\(/.test(content.trim());
                if (!startsWithFunction) return;
                updateContent = `${content}${newRef}`;
              } else {
                updateContent = `${content};${newRef}`;
              }
            }
          }
        } else {
          updateContent = this.updateFormulaRef(content, newRef);
        }
        if (updateContent.length) cellDiv.innerText = updateContent;
        setCursorAtLast(cellDiv);
      } catch (error) {
        console.log('error', error);
      } finally {
        this.onInput({ target: cellDiv });
      }
    },
  },
  mounted() {
    this.setInitialValue();
  },
};
</script>
<style scoped>
.input-cell {
  cursor: default;
}
</style>
